import { FC, PropsWithChildren } from 'react';
import { cn } from '@/utils/classNames.ts';
import AppLogo from '@/components/ui/AppLogo/AppLogo.tsx';
import { PropsWithClassName } from '@/types/PropsWithClassName';

const BrandCardSideContent: FC<PropsWithChildren<PropsWithClassName>> = ({ children, className }) => {
  return (
    <div
      className={cn(
        'flex flex-col md:grid md:grid-cols-2 shadow-xl rounded-2xl  max-w-full w-full md:w-[1048px] md:min-h-[500px] lg:min-h-[624px]',
        className
      )}
    >
      <div className="flex items-center justify-center py-6 px-6 md:p-8 bg-light-gray rounded-t-2xl md:rounded-l-2xl md:rounded-tr-none">
        <AppLogo.LogoOnly className="w-[120px] md:w-[200px] max-w-full" />
      </div>
      <div className="bg-white flex flex-col justify-center rounded-b-2xl md:rounded-r-2xl md:rounded-bl-none items-center gap-4 p-4 md:p-8 lg:p-10">
        {children}
      </div>
    </div>
  );
};

export default BrandCardSideContent;
